// extracted by mini-css-extract-plugin
export default {"emptyBox":"EmptyBox_emptyBox__rxfHm","message":"EmptyBox_message__KUSF0"};